import { css } from '@emotion/core';
import { BasisFont, trackedStyles } from './typography';
import { DESKTOP_START_QUERY } from './responsive';

export default css`
  ${BasisFont};
  ${trackedStyles};
  border-radius: 0;
  border-style: solid;
  border-width: 2px;
  cursor: pointer;
  display: inline-block;
  height: 40px;
  margin: 0;
  outline: none;
  padding: 13px 20px 13px;
  transition: background-color ease 0.06s, border-color ease 0.06s;
  text-transform: uppercase;

  @media (${DESKTOP_START_QUERY}) {
    height: 48px;
    padding: 15px 24px 17px;
  }
`;
